"use client";

import type { SupportedLang } from "@acme/validators";

import { useStudioStore } from "~/app/(studio)/studio/_hooks/use-studio-store";
import { ActionBar } from "./action-bar";
import { LanguageSelector } from "./action-bar/language-selector";
import { RuleEditorTabs } from "./action-bar/rule-editor-tabs";
import { ProjectDropdown } from "./project-dropdown";

export function StudioHeader() {
  const lang = useStudioStore((state) => state.lang);
  const resetState = useStudioStore((state) => state.resetState);

  const handleNewSessionClick = (selectedLang?: SupportedLang) => {
    resetState(selectedLang ?? lang);
  };

  return (
    <div className="grid w-full grid-cols-3 items-center">
      <div className="flex items-center gap-0.5 justify-self-start">
        <ProjectDropdown />
        <LanguageSelector
          onChange={(selectedLang: SupportedLang) => {
            handleNewSessionClick(selectedLang);
          }}
          value={lang}
        />
      </div>

      <div className="justify-self-center">
        <RuleEditorTabs />
      </div>

      <div className="justify-self-end">
        <ActionBar />
      </div>
    </div>
  );
}
